import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData, postFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast/toastBaseSlice";
import AlertInterface from "features/toast/toastInterface";

interface InsigniaState {
    status: string;
    error: string;
    insigniaList: any[];
    insignia: {
        idInsignia: number | null;
        nombre: string | null;
        descripcion: string | null;
        puntajeMinimo: number | null;
        puntajeMaximo: number | null;
        fileImage: string | null;
        fileData: string | null;
        estado: number | null;
    }
}

const initialState: InsigniaState = {
    status: 'idle',
    error: '',
    insigniaList: [],
    insignia: {
        idInsignia: null,
        nombre: null,
        descripcion: null,
        puntajeMinimo: null,
        puntajeMaximo: null,
        fileImage: null,
        fileData: null,
        estado: null
    }
}

export const fetchInsignia = createAsyncThunk('fetchInsignia', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 313;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateInsignia = createAsyncThunk('modifyCreateInsignia', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const insigniaNew = selectInsignia(state);
    const insigniaAttributes = {
        idInsignia: insigniaNew.idInsignia,
        nombre: insigniaNew.nombre,
        descripcion: insigniaNew.descripcion,
        puntajeMinimo: insigniaNew.puntajeMinimo,
        puntajeMaximo: insigniaNew.puntajeMaximo,
        fileData: insigniaNew.fileData
    };
    const idsp = insigniaAttributes.idInsignia ? 310 : 309;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...insigniaAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (insigniaAttributes.fileData !== null && insigniaAttributes.fileData !== '') {
            const { result } = await postFile({ idsp: 312, id: data, dir: "insignias", fileData: insigniaAttributes.fileData, fileName: data }, getState, dispatch);
            if (!result) {
                alert = { title: 'ACCIÓN INCOMPLETA', message: "IMAGEN NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }

    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchInsignia({}));
    return rejectWithValue(message);
});

export const updateEstadoInsignia = createAsyncThunk('updateEstadoInsignia', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const insigniaNew = selectInsignia(state);
    const insigniaAttributes = { ...insigniaNew }
    const estado = !insigniaAttributes.estado;
    const idInsignia = insigniaAttributes.idInsignia;
    const idsp = 311;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, estado, idInsignia }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchInsignia({}));
    return rejectWithValue(message);
});

export const insigniaSlice = createSlice({
    name: 'insignia',
    initialState,
    reducers: {
        setInsigniaList: (state, action) => {
            state.insigniaList = action.payload;
        },
        setInsignia: (state, action) => {
            state.insignia = !action.payload ? initialState.insignia : { ...initialState.insignia, ...action.payload };
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchInsignia.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchInsignia.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.insigniaList = data ? data : [];
            })
            .addCase(fetchInsignia.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectInsigniaList = (state: RootState) => state.insignia.insigniaList;
export const selectInsignia = (state: RootState) => state.insignia.insignia;

export const { setInsigniaList, setInsignia } = insigniaSlice.actions;

export default insigniaSlice.reducer;
